module.exports = __webpack_public_path__ + "img/gzkx.14678d9b.png";